import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getBodyPartsStats,
  getReportData,
} from "../../services/ViewReportServices";
import HumanOverallReport from "../HumanOverallReport/HumanOverallReport";
import AssessmentOverview from "../../components/AssessmentOverview/AssessmentOverview";
import AssessmentOverallSummary from "../../components/AssessmentOverallSummary/AssessmentOverallSummary";
import ViewRomReport from "../../components/ViewRomReport/ViewRomReport";
import ViewRepReport from "../../components/ViewRepReport/ViewRepReport";
import ViewHoldReport from "../../components/ViewHoldReport/ViewHoldReport";
import { useAuth } from "../../auth";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { convertUTCtoLocalDate } from "../../utils/CommonUtils";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { getPdfUrl } from "../../services/DashboardServices";

const ViewIndividualReport = () => {
  const [reportData, setReportData] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const auth = useAuth();
  const open = Boolean(anchorEl);
  const [boyPartsReport, setBoyPartsReport] = React.useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("session_id");
  const { userId } = useParams();
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    if (sessionId) {
      getBodyPartsStats(sessionId).then((res) => {
        setBoyPartsReport(res.data.latest_exercise_stats);
      });
      getReportData(sessionId).then((res) => {
        console.log("data", res);
        setReportData(res.data);
      });
    }
  }, [sessionId]);
  const getPdfUrlHandler = (sessionId) => {
    getPdfUrl(sessionId).then((res) => {
      if (res && res.data && res.data.data) {
        console.log(res.data.data);
        const a = document.createElement("a");
        a.href = res.data.data;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(res.data.data);
        setDownloading(false);
      } else {
        setDownloading(false);
      }
    });
  };
  const refreshDataHandler = () => {
    getReportData(sessionId).then((res) => {
      setReportData(res.data);
    });
  };
  const getFirstLetter = (name) => {
    return name.charAt(0);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    auth.logout();
  };

  return (
    <div>
      <div className="flex mb-4">
        <div
          className="flex cursor-pointer items-center text-[#415280] font-semibold text-sm cursor-pointer"
          onClick={() => {
            navigate(`/user-data/${userId}`);
          }}
        >
          <div>
            <ArrowBackIcon />
          </div>
          Back to list
        </div>
      </div>
      <div>
        <div
          className="bg-[#415280] text-[#fff] text-xs leading-[18px] font-semibold px-6 py-4
          flex justify-between items-center
            "
        >
          <div>
            {reportData && reportData.date && (
              <>
                <span className="text-base font-medium">Created Date </span> :{" "}
                <span className="text-lg font-semibold">
                  {" "}
                  {convertUTCtoLocalDate(reportData.date)}
                </span>
              </>
            )}
          </div>
          <div
            className="py-1 px-3 bg-white rounded-[5px] "
            style={{
              border: "1px solid #788CFC",
            }}
          >
            {!downloading && (
              <div
                className="flex gap-1 items-center text-[#788CFC] font-medium"
                onClick={() => {
                  setDownloading(true);
                  getPdfUrlHandler(sessionId);
                }}
              >
                <FileDownloadOutlinedIcon />
                <span>Export</span>
              </div>
            )}
            {downloading && (
              <div className="text-[#475467] font-normal text-sm leading-5">
                Downloading...
              </div>
            )}
          </div>
        </div>

        <div className="mt-12">
          {" "}
          <HumanOverallReport data={boyPartsReport} />
        </div>
        <div className="">
          <div
            className="text-[#3F3D56] text-xl font-semibold mb-11"
            style={{
              fontFamily: "Poppins",
            }}
          >
            Assessment category overviews
          </div>
          <div className="mb-11">
            {reportData && reportData.assessment_stats && (
              <AssessmentOverview data={reportData.assessment_stats} />
            )}
          </div>
          <div className="mb-16">
            {reportData && reportData.assessment_stats && (
              <AssessmentOverallSummary data={reportData.assessment_stats} />
            )}
          </div>
        </div>
        <div className="border border-solid border-[#DADFFF] px-[52px] pt-6 bg-white">
          <div>
            {reportData.mobility_and_flexibility_response &&
              reportData.mobility_and_flexibility_response
                .mobility_and_flexibility_exercise_results && (
                <ViewRomReport
                  data={
                    reportData.mobility_and_flexibility_response
                      .mobility_and_flexibility_exercise_results
                  }
                  refreshDataHandler={refreshDataHandler}
                />
              )}
          </div>
          <div>
            {reportData.strength_and_endurance_response &&
              reportData.strength_and_endurance_response.reps_output_list && (
                <ViewRepReport
                  data={
                    reportData.strength_and_endurance_response.reps_output_list
                  }
                  refreshDataHandler={refreshDataHandler}
                />
              )}
          </div>
          <div>
            {reportData.balance_response &&
              reportData.balance_response
                .assessment_report_for_balance_list && (
                <ViewHoldReport
                  data={
                    reportData.balance_response
                      .assessment_report_for_balance_list
                  }
                  refreshDataHandler={refreshDataHandler}
                />
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewIndividualReport;
